import ObjectIdField from "../../components/ObjectIdField";
import { Box } from "@mui/material";
import * as React from "react";
import { buildField } from "../Field";
import { MyField } from "../../components/types";
import { base, BaseArgs } from "./base";
import { TextArgs } from "./text";
import { TextField, TextInput } from "react-admin";

export interface ObjectIdArgs extends Partial<BaseArgs> {}

const defaultArgs: BaseArgs = {
  label: "ID",
  source: "id",
  isEdit: true,
  isCreate: false,
  isUpdate: false,
  isFilter: false,
  isList: true,
};

export function objectId(args: ObjectIdArgs = {}, field?: MyField) {
  return base(
    {
      ...defaultArgs,
      ...args,
    },
    {
      sortable: true,
      component: ObjectIdField,
      editComponent: Box,
      editProps: {
        children: (
          <>
            ID:
            <ObjectIdField fullWidth />
          </>
        ),
      },
    },
    field
  );
}
